<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		<div class="topUp_1">{{$t('饭票充值')}}</div>
		<div class="topUp_2">{{$t('套餐购买，默认自动续费。在饭票低于5张时候，自动充值。可在个人中心设置里面进行取消')}}</div>
	    <div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div class="flex flex-wrap">
				<template v-for="(item,index) in chong_list">
					<div @click.stop="list_item = item" class="flex flex-direction align-stretch justify-center benben-flex-layout pointer" :class="list_item.aid == item.aid ? 'topUp_3s':'topUp_3'">
						<div class="flex topUp_4">
							<!-- 20张饭票 -->
							<div class="topUp_5 flex-sub">{{item.name}}</div>
							<div class="topUp_6">${{item.price}}</div>
						</div>
						<div class="topUp_7" v-if="item.type!=1">{{$t('额外赠送')}}{{item.gift_num}}{{$t('张好友饭票')}}</div>
						<div class="flex topUp_8" v-if="item.type==1">
							<img class="topUp_8_1 pointer" @click="caozuo(4,index)" src="https://api.ezlunch.club/pc/image/22.png" alt="" srcset="">
							<div class="topUp_8_2">{{item.num}}</div>
							<img class="topUp_8_1 pointer" @click="caozuo(5,index)" src="https://api.ezlunch.club/pc/image/23.png" alt="" srcset="">
						</div>
					</div>
				</template>
			</div>
			<div class="flex topUp_9">
				<div class="topUp_9_1 pointer" @click="post68d4ffd86eaa5">{{$t('立即充值')}}</div>
				<div class="topUp_9_2 pointer" @click="caozuo(3)">{{$t('查看充值订单')}}</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				loading:true,
				chong_list:[],
				list_item:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68d2173c73087()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = false
				this.post68d2173c73087()
			},
			//饭票充值提交订单
			post68d4ffd86eaa5(){
				
				
				this.$api.post(this.$apiUrls.post68d4ffd86eaa5,{
					meal_ticket_id:this.list_item.aid,
					num:this.list_item.num,
				}).then((res) => {
					console.log(res,124)
					if(res.code == 1){
						let dete = res.data
						dete.num_s = this.list_item.num
						dete.name_s = this.list_item.name
						
						window.sessionStorage.setItem('payItem',JSON.stringify(dete));
						this.$router.replace({
							name: 'topUpPay',
						});
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			//获取饭票充值列表
			post68d2173c73087(){
				this.$api.post(this.$apiUrls.post68d2173c73087).then((res) => {
					if(res.code == 1){
						this.chong_list = res.data
						if(!this.list_item){
							this.list_item = this.chong_list[0]
						}
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){
					window.history.back();
					return
				}else if(type == 2){
					// url = 'topUpPay'
				}else if(type == 3){
					url = 'topUpList'
				}else if(type == 4){ // 减
					if(this.chong_list[item].num > 1){
						this.chong_list[item].num--
					}
					return
				}else if(type == 5){ // 加
					this.chong_list[item].num++
					return
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.topUp_1{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
		margin: 27px 0 6px 0;
	}
	.topUp_2{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 0 0 32px 0;
	}
	.topUp_3{
		width: 302px;
		// height: 96px;
		background: #F6F7F9;
		border: 1px solid #F6F7F9;
		border-radius: 8px 8px 8px 8px;
		margin: 0 16px 24px 0;
		padding: 12px 24px;
	}
	.topUp_3s{
		width: 302px;
		// height: 96px;
		background: #FFF9F4;
		border: 1px solid #FF8A24;
		border-radius: 8px 8px 8px 8px;
		margin: 0 16px 24px 0;
		padding:12px 24px;
	}
	.topUp_5{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}
	.topUp_6{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
		margin: 0 0 0 10px;
	}
	.topUp_7{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 10px 0 0 0;
	}
	.topUp_8{
		margin: 10px 0 0 0;
	}
	.topUp_8_1{
		width: 20px;
		height: 20px;
	}
	.topUp_8_2{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 12px;
	}
	.topUp_9{
		margin: 16px 0 0 0;
	}
	.topUp_9_1{
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		line-height: 48px;
		padding: 0 30px;
		margin: 0 16px 0 0;
	}
	.topUp_9_2{
		font-weight: 400;
		font-size: 16px;
		color: #FF7721;
		height: 48px;
		border-radius: 8px 8px 8px 8px;
		line-height: 48px;
		padding: 0 30px;
		border: 1px solid #FF7721;
	}
</style>